<template>
  <div id="app">
    <layout>
      <template v-slot:header>
        <Header />
      </template>
      <template v-slot:pages>
        <router-view />
      </template>
      <template v-slot:footer>
        <Footer />
      </template>
    </layout>
  </div>
</template>
<script>
import { mapGetters, mapActions } from 'vuex';
import layout from '@/layouts/default.vue';
import Header from '@/components/Header.vue';
import Footer from '@/components/Footer.vue';

export default {
  name: 'App',
  data() {
    return {};
  },
  computed: {
    ...mapGetters(['screenWidth']),
  },
  components: {
    layout,
    Header,
    Footer,
  },
  metaInfo: {
    titleTemplate: '財團法人天主教主顧修女會奇蹟之家%s',
    meta: [
      { charset: 'utf-8' },
      { name: 'viewport', content: 'width=device-width, initial-scale=1' },
      {
        hid: 'description',
        name: 'description',
        content: '奇蹟之家是社區照顧服務的機構，以愛與專業的照顧，守護社區中失智與失能的民眾。',
      },
      { property: 'og:title', content: '財團法人天主教主顧修女會奇蹟之家' },
      {
        property: 'og:description',
        content: '奇蹟之家是社區照顧服務的機構，以愛與專業的照顧，守護社區中失智與失能的民眾。',
      },
      { property: 'og:site_name', content: '財團法人天主教主顧修女會奇蹟之家' },
      {
        property: 'og:locale',
        content: 'zh_TW',
      },
      { property: 'og:image', content: `${process.env.BASE_URL}og-logo.svg` },
    ],
    htmlAttrs: {
      lang: 'zhTW',
    },
  },
  methods: {
    ...mapActions(['update_width']),
    handleResize() {
      this.update_width(window.innerWidth);
    },
  },
  mounted() {
    const vm = this;
    window.onresize = () => (() => {
      window.screenWidth = document.body.clientWidth;
      vm.update_width(window.screenWidth);
    })();
  },
  watch: {
    screenWidth(val) {
      this.update_width(val);
    },
  },
};
</script>
